var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1803.84 745.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 901.92,
    y1: 480.81,
    x2: 901.92,
    y2: -7.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a1b44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0b1e49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0f2757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#16366f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#204b91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2c66bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#3a87ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f91ff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M344.71,40c102.81-25.8,376-94.87,459.76,44.51S998.29,313.08,1281.54,258s351.37-234.06,458.8-35.72S1876,580.62,1351.59,630.31,752.82,838.86,367.72,669.4-55.7,400.38,52.3,231.74,241.9,65.83,344.71,40Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact4);
export default __webpack_public_path__ + "static/media/contact4.e7b99c8009893a20fb8d35c2f12bf2c1.svg";
export { ForwardRef as ReactComponent };